/** @file useArtKeys: pushes the `art` key context and registers `artBindings` while Art is mounted. */
import { pushContext } from '@zilo/pose3d-shortcuts/pushContext';
import { registerBindings } from '@zilo/pose3d-shortcuts/registerBindings';
import { useEffect, useRef } from 'react';
import { artBindings } from './artBindings';

/** Registers once; each key calls the latest `handlers[id]` (handlers may change every render). */
export function useArtKeys(handlers: Record<string, () => void>): void {
  const latest = useRef(handlers);
  latest.current = handlers;
  useEffect(() => {
    const stable = Object.fromEntries(artBindings.map((b) => [b.id, () => { latest.current[b.id]?.(); }]));
    const pop = pushContext('art');
    const unregister = registerBindings('art', artBindings, stable);
    return () => { unregister(); pop(); };
  }, []);
}
